import React from "react";
import { addrColor } from "../../lib/format";

export function Panel({ title, subtitle, action, menu, children, className = "", bodyClass = "", testId }) {
  return (
    <div className={`panel ${className}`} data-testid={testId}>
      {(title || action || menu) && (
        <div className="panel-head">
          <div className="flex items-baseline gap-2 min-w-0">
            <span className="panel-title truncate">{title}</span>
            {subtitle && <span className="text-[11px] font-mono truncate" style={{ color: "var(--muted-2)" }}>{subtitle}</span>}
          </div>
          <div className="flex items-center gap-3 shrink-0">
            {action}
            {menu !== false && (
              <button className="panel-dots" data-testid="panel-menu" tabIndex={-1}>
                <i className="fa-solid fa-ellipsis" />
              </button>
            )}
          </div>
        </div>
      )}
      <div className={bodyClass}>{children}</div>
    </div>
  );
}

export function Avatar({ address, size = 18 }) {
  const c = addrColor(address);
  return (
    <span
      className="inline-block rounded-full shrink-0"
      style={{
        width: size, height: size,
        background: `radial-gradient(circle at 30% 30%, ${c}, ${c}55)`,
        border: `1px solid ${c}66`,
      }}
    />
  );
}

export function TokenLogo({ logo, symbol, size = 26 }) {
  if (logo) {
    return (
      <img
        src={logo}
        alt={symbol}
        width={size}
        height={size}
        className="rounded-full object-cover shrink-0"
        style={{ border: "1px solid var(--border-2)", background: "var(--bg-2)" }}
        onError={(e) => { e.currentTarget.style.display = "none"; }}
      />
    );
  }
  const c = addrColor(symbol || "?");
  return (
    <span
      className="inline-flex items-center justify-center rounded-full shrink-0 font-display font-bold"
      style={{
        width: size, height: size, fontSize: size * 0.42, color: "#0a0a0a",
        background: `radial-gradient(circle at 30% 30%, ${c}, ${c}aa)`,
      }}
    >
      {(symbol || "?").slice(0, 1).toUpperCase()}
    </span>
  );
}

export function VerifiedBadge({ small }) {
  return (
    <span className={`pill pill-green ${small ? "text-[10px]" : ""}`} title="Verified">
      <i className="fa-solid fa-circle-check" /> Verified
    </span>
  );
}

export function StarButton({ starred, onToggle, size = 13, testId }) {
  return (
    <button
      type="button"
      className="icon-btn"
      title={starred ? "Remove from watchlist" : "Add to watchlist"}
      data-testid={testId}
      onClick={(e) => { e.stopPropagation(); e.preventDefault(); onToggle?.(); }}
      style={{ width: 30, height: 30 }}
    >
      <i className="fa-solid fa-star" style={{ fontSize: size, color: starred ? "var(--amber)" : "var(--border-2)" }} />
    </button>
  );
}

export function LiveTag({ label = "Live" }) {
  return (
    <span className="flex items-center gap-1.5 text-[11px] font-mono" style={{ color: "var(--muted)" }}>
      <span className="dot dot-green live-dot" /> {label}
    </span>
  );
}

export function Logo({ size = 28 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none">
      <path d="M16 2L28 9V23L16 30L4 23V9L16 2Z" stroke="var(--amber)" strokeWidth="1.6" fill="rgba(245,166,35,0.08)" />
      <path d="M16 9L22 12.5V19.5L16 23L10 19.5V12.5L16 9Z" fill="var(--amber)" />
      <circle cx="16" cy="16" r="2.4" fill="#0a0a0a" />
    </svg>
  );
}

export function StatBox({ label, value, sub, icon, accent, testId }) {
  return (
    <div className="panel card-hover p-5 fade-in" data-testid={testId}>
      <div className="flex items-center justify-between mb-3">
        <span className="eyebrow">{label}</span>
        {icon && <i className={`${icon}`} style={{ color: accent || "var(--amber)", fontSize: 14 }} />}
      </div>
      <div className="stat-value text-[26px]" style={{ color: "var(--text)" }}>{value}</div>
      {sub && <div className="mt-1.5 text-[12px]" style={{ color: "var(--muted)" }}>{sub}</div>}
    </div>
  );
}
